import type { AgentRequest, AgentResponse } from "./types";
import { apiRequest } from "./request";

export const agentApi = {
  async query(tenantId: string, siteId: string, cameraKey: string, request: AgentRequest): Promise<AgentResponse> {
    console.log("Request:", JSON.stringify(request, null, 2));

    const data = await apiRequest<AgentResponse>({
      method: "POST",
      path: `/api/v1/tenants/${tenantId}/sites/${siteId}/cameras/${cameraKey}/agent`,
      body: request,
      logMessage: "Calling agent API:",
    });

    console.log("Agent API response:", JSON.stringify(data, null, 2));
    return data;
  },
};
